// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1YJDG","active":"downloadDropdown_active__3PFsr"};